import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import { CalculatorSidebar, WorkspaceViewId } from '../components/CalculatorNavigation';

const AppLayout: React.FC = () => {
  const [activeCalculator, setActiveCalculator] = useState<WorkspaceViewId>('runway');

  return (
    <div className="app">
      <ScrollToTop />
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <Navbar />
      <div className="workspace-shell">
        <CalculatorSidebar
          activeCalculator={activeCalculator}
          onSelectCalculator={setActiveCalculator}
        />
        <main className="workspace-main" id="main-content">
          <Outlet context={{ activeCalculator, onSelectCalculator: setActiveCalculator }} />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default AppLayout;